import { render } from "./ButtonVue.vue?vue&type=template&id=58d62a15"
import script from "./ButtonVue.vue?vue&type=script&lang=js"
export * from "./ButtonVue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__